import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {RestoreUtils} from "../misc/RestoreUtils";

export class DoNormalBet implements SimplePresentation {

    shouldRun(): boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        const isFastDrops = FlightMode.apiPlugin.settings.get(APISetting.FAST_SPIN);
        RestoreUtils.isActionSpins = false;
        const showNoWin = FlightMode.model.nothingHappened() &&
                          FlightMode.seedableRandom.nextNumber() < 0.03;

        tl.add(() => {
            if (FlightMode.model.hasStartingMultipliers() &&
                FlightMode.model.startingMultiplier() <= FlightMode.reelView.getCurrentMultiplier())
                FlightMode.reelView.resetMultiplierCounterTo(FlightMode.model.startingMultiplier());
            else
               FlightMode.reelView.resetMultiplierCounter();
            if(showNoWin)
                FlightMode.backgroundElements.fadeInNoWin();
        })
        tl.add(FlightMode.reelView.dropOutSymbols(isFastDrops));
        //tl.add(FlightMode.reelView.reel.start());

        tl.add(() => { controller.finish() }, showNoWin ? ">0.575" : ">");
    }
}
